<i18n>
{
  "en": {
    "title": "Identity Verification",
    "country": "Country",
    "firstName": "First Name",
    "lastName": "Last Name",
    "date": "Birth Date",
    "whyweneedid": "We need to confirm your identity with a government issued ID. Before proceeding, upload one of the following forms of ID.",
    "government": "Government Issued ID",
    "driver": "Valid Driver’s License",
    "national": "National Identity Card",
    "verifdone": "Identity verification was successful.",
    "verifinprogress": "We are currently processing your verification. You can check your verification status in the Verification Center.",
    "profile": "Profile",
    "deposit": "Deposit"
  },
  "zh": {
    "title": "认证",
    "country": "国家",
    "firstName": "名字",
    "lastName": "姓氏",
    "date": "出生日期",
    "whyweneedid": "我们需要使用政府签发的身份证件来确认您的身份。 在继续之前，请上传以下 ID 形式之一。",
    "government": "政府签发的 ID",
    "driver": "有效驾照",
    "national": "国民身份证",
    "verifdone": "认证成功。",
    "verifinprogress": "认证正在进行中。",
    "profile": "个人资料",
    "deposit": "定金"
  },
  "kr": {
    "title": "본인 확인",
    "country": "국가",
    "firstName": "이름",
    "lastName": "성",
    "date": "생년월일",
    "whyweneedid": "정부 발급 신분증으로 신원을 확인해야 합니다. 계속하기 전에 다음 형식의 신분증 중 하나를 업로드하세요.",
    "government": "정부 발급 ID",
    "driver": "유효한 운전면허증",
    "national": "국가 신분증",
    "verifdone": "본인 확인에 성공했습니다.",
    "verifinprogress": "본인 확인이 진행 중입니다.",
    "profile": "프로필",
    "deposit": "보증금"
  }
}
</i18n>
<template>
  <Page :is-page-loaded="dataLoadingStatus" :title="$t('title')" :no-line="true" class="dashboard">
    <PageContainer style="margin: 0; align-items: center; display: flex;"  :no-line="true" class="row">

      <div class="col-lg-12 verification-card" :class="{ dark: $store.state.Index.isDarkMode }">
        <div style="margin-bottom: 60px;" v-if="!$store.state.Index.userInfo.settings.kyc.isDepositVerified || !$store.state.Index.userInfo.settings.kyc.isVerified">
          <h2 v-if="!$store.state.Index.userInfo.settings.kyc.isVerified">Step 1. Your Information</h2>
          <h2 v-if="!$store.state.Index.userInfo.settings.kyc.isDepositVerified && $store.state.Index.userInfo.settings.kyc.isVerified">Step 2. Account Activation</h2>
        </div>
        <div style="margin: 0;" class="kyc col-lg-12 row">
          <div style="text-align: center;" v-if="$store.state.Index.userInfo.settings.kyc.isVerified || $store.state.Index.userInfo.settings.kyc.isConsidering">
            <div v-if="$store.state.Index.userInfo.settings.kyc.isVerified && $store.state.Index.userInfo.settings.kyc.isDepositVerified">
              <svg style="box-sizing: border-box; margin: 0px; min-width: 0px; color: currentcolor; font-size: 90px; fill: currentcolor; width: 1em;height: 1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" class="css-ade6fb"><g clip-path="url(#success-b96_svg__clip0)" fill="#00C087"><path d="M71 25a32.523 32.523 0 00-22.96-9.52c-17.95-.01-32.51 14.53-32.52 32.48C15.51 65.91 30.05 80.47 48 80.48c17.95.01 32.51-14.53 32.52-32.48 0-8.63-3.42-16.9-9.52-23zM42.04 60.5L30.97 49.43l2.12-2.12 8.95 8.95 20.91-20.91 2.13 2.13L42.04 60.5zM46.48 2.51L46.56 5H49l.03-2.49h-2.55zm5.65.16l-.22 2.49c.79.07 1.6.17 2.39.28l.36-2.47c-.84-.12-1.69-.22-2.53-.3zm-8.7 0c-.84.08-1.69.19-2.52.33l.39 2.51c.78-.13 1.59-.23 2.38-.35l-.25-2.49zm14.19.83l-.53 2.44c.78.17 1.57.37 2.34.58l.66-2.41c-.81-.23-1.64-.43-2.47-.61zm-19.71.11c-.83.19-1.66.4-2.47.64l.69 2.4c.77-.22 1.56-.42 2.33-.6l-.55-2.44zM63 5l-.79 2.38c.75.26 1.51.55 2.25.86l.92-2.33C64.6 5.58 63.8 5.28 63 5zm-30.46.19c-.79.29-1.59.61-2.37.94l1 2.29c.73-.32 1.48-.61 2.22-.88l-.85-2.35zm-1.37 3.24v-.01c-.01 0-.01.01-.02.01h.02zm36.99-1.24l-1.11 2.24c.71.36 1.43.74 2.12 1.13l1.24-2.17c-.74-.42-1.5-.82-2.25-1.2zm-40.78.24c-.75.38-1.5.79-2.23 1.22l1.26 2.16h.02c.69-.41 1.4-.81 2.09-1.16l-1.14-2.22zM73 10l-1.39 2.07c.69.44 1.36.9 2 1.38l1.48-1.99C74.41 11 73.71 10.47 73 10zm-50.44.26c-.7.49-1.39.97-2.07 1.49l1.51 2c.66-.49 1.32-.96 2-1.41l-1.44-2.08zm54.94 3.08l-1.62 1.91c.61.52 1.21 1.06 1.79 1.61l1.72-1.81c-.59-.59-1.22-1.16-1.89-1.71zm-59.37.34c-.63.56-1.26 1.14-1.87 1.73L18 17.2c.58-.56 1.18-1.11 1.77-1.63l-1.64-1.89zm63.42 3.55l-1.85 1.69c.58.59 1.07 1.2 1.58 1.82l1.93-1.58c-.53-.65-1.09-1.3-1.66-1.93zm-67.4.38c-.56.63-1.12 1.28-1.65 1.94l1.95 1.57c.55-.63 1.03-1.24 1.55-1.84l-1.85-1.67zm70.92 3.97l-2 1.45c.46.65.92 1.33 1.34 2l2.08-1.33c-.42-.72-.93-1.43-1.42-2.12zm-74.4.42c-.48.7-.95 1.41-1.39 2.13l2.13 1.31c.41-.68.86-1.35 1.32-2.01L10.67 22zM88 26.33l-2.22 1.19c.38.7.75 1.43 1.09 2.15l2.28-1.07c-.36-.76-.75-1.53-1.15-2.27zm-80.28.5c-.39.74-.77 1.51-1.12 2.28l2.27 1h.04c.33-.73.69-1.45 1.09-2.11l-2.28-1.17zm82.66 4.58l-2.33.91c.29.74.57 1.51.82 2.27l2.37-.79c-.26-.8-.55-1.61-.86-2.39zm-84.92.48c-.3.8-.58 1.61-.83 2.41l2.37.75c.25-.76.51-1.52.8-2.27l-2.34-.89zm86.65 4.85l-2.42.62c.19.77.37 1.56.53 2.34l2.45-.48c-.16-.83-.35-1.66-.56-2.48zm-88.3.51c-.2.82-.38 1.66-.53 2.49l2.46.45c.14-.78.31-1.58.5-2.35l-2.43-.59zm89.34 4.99l-2.48.31c.1.79.18 1.6.24 2.4l2.49-.18c-.06-.84-.14-1.69-.25-2.53zm-90.32.52c-.1.84-.22 1.7-.22 2.54l2.5.15c.04-.8.11-1.61.2-2.4l-2.48-.29zm88.23 5.07v.14c0 .8-.06 1.61-.06 2.41l2.44.14c.05-.84.07-1.7.12-2.52v-.17h-2.5zm-86.03.53h-2.5c.01.84.04 1.7.1 2.54l2.49-.14c-.09-.79-.09-1.6-.09-2.4zm85.66 4.9c-.1.8-.22 1.6-.36 2.38l2.46.44c.15-.83.28-1.67.38-2.52l-2.48-.3zm-85.29.36l-2.48.32c.11.84.25 1.69.4 2.52l2.46-.47a37.7 37.7 0 01-.38-2.37zm84.32 4.84c-.19.78-.41 1.56-.65 2.32l2.39.74c.25-.8.48-1.63.69-2.45l-2.43-.61zm-83.31.35l-2.42.63c.21.82.45 1.64.71 2.44l2.38-.76c-.24-.76-.47-1.54-.67-2.31zm81.71 4.73c-.28.74-.6 1.49-.93 2.22l2.28 1c.35-.76.68-1.56.98-2.32l-2.33-.9zm-80.07.3l-2.32.92c.31.78.65 1.57 1 2.34L9 66.04c-.33-.72-.65-1.46-.95-2.2zm80.07 5.64l-2.21-1.18c-.37.7-.78 1.41-1.19 2.09l2.13 1.3v.02c.44-.71.87-1.47 1.27-2.23zM10.3 68.6l-2.19 1.2c.4.74.84 1.48 1.28 2.2l2.13-1.32c-.43-.68-.84-1.38-1.22-2.08zm72.78 4.22c-.44.65-.95 1.3-1.44 1.93l2 1.55h.01c.52-.66 1.04-1.3 1.43-2.04l-2-1.44zm-69.99.3l-2 1.46c.5.66 1.01 1.34 1.55 2l1.91-1.54c-.46-.62-.99-1.27-1.46-1.92zm66.73 3.83c-.46.47-.92 1-1.4 1.47l-.27.27 1.76 1.78.28-.28c.48-.51 1-1.02 1.48-1.56l-1.85-1.68zm-63.35.24l-1.84 1.7c.57.62 1.17 1.23 1.78 1.82l1.74-1.8c-.58-.55-1.14-1.13-1.68-1.72zm59.54 3.43c-.6.52-1.23 1.03-1.87 1.52l1.52 2h.01c.67-.51 1.33-1.05 1.97-1.62l-1.63-1.9zm-55.74.23l-1.61 1.91c.66.59 1.33 1.08 2 1.59l1.49-1.99c-.64-.51-1.27-.99-1.88-1.51zm51.46 2.98c-.62.45-1.31.88-2 1.28L71 87.27c.76-.43 1.48-.89 2.12-1.36l-1.39-2.08zm-47.2.17l-1.4 2.11c.71.47 1.44.92 2.17 1.34l1.23-2.19c-.64-.4-1.33-.82-2-1.26zm42.65 2.51c-.71.34-1.45.68-2.18 1l1 2.29c.81-.34 1.59-.7 2.3-1.06l-1.12-2.23zm-38.05.18l-1.1 2.25c.76.37 1.54.73 2.32 1.06l.97-2.31c-.73-.3-1.47-.64-2.19-1zm33.23 1.87c-.76.27-1.53.52-2.29.74l.7 2.4c.81-.24 1.62-.5 2.42-.78l-.83-2.36zM34 88.68l-.79 2.36c.8.28 1.62.54 2.43.77l.66-2.41c-.77-.22-1.54-.46-2.3-.72zm23.27 1.34c-.78.17-1.57.32-2.36.45l.4 2.47c.83-.14 1.69-.3 2.5-.48l-.54-2.44zm-18.15.07l-.52 2.45c.83.17 1.68.33 2.51.46l.38-2.48c-.79-.12-1.59-.26-2.37-.43zm12.93.75c-.8.08-1.6.16-2.4.16l.09 2.49c.84-.03 1.7-.09 2.54-.16l-.23-2.49zm-7.7.02l-.21 2.5c.85.07 1.7.14 2.54.14l.08-2.5c-.8-.02-1.61-.07-2.41-.14z"></path></g><defs><clipPath id="success-b96_svg__clip0"><path fill="#fff" d="M0 0h96v96H0z"></path></clipPath></defs></svg>
            <h3>Verification Complete</h3>
              {{ $t('verifdone') }}
            </div>
            <div v-if="$store.state.Index.userInfo.settings.kyc.isConsidering && !$store.state.Index.userInfo.settings.kyc.isVerified">
              <img width="50px" src="/clocks.png" style="margin-bottom: 15px;" alt="">
              <h3>Processing</h3>
              {{ $t('verifinprogress') }}
            </div>
            <div v-if="$store.state.Index.userInfo.settings.kyc.isVerified && !$store.state.Index.userInfo.settings.kyc.isDepositVerified">
              <img width="250px" src="/undraw_payments.svg" style="margin-bottom: 15px;" alt="">
              <div class="alert">
                {{ verificationMessage }}
                <div style="display: flex; align-items: center; justify-content: center;">
                  <div style="text-align: center; display: flex; justify-content: center; margin-top: 20px; margin-right: 20px;">
                    <Button :callback="() => $router.push($linkCreator($i18n.locale, 'dashboard/wallets/deposit'))" style="width: 150px;">{{ $t('deposit') }}</Button>
                  </div>
                  <div style="text-align: center; display: flex; justify-content: center; margin-top: 20px;">
                    <Button
                        :callback="() => $store.state.Index.isLiveSupportEnabled ? $store.dispatch('Index/openLiveSupport', true) : $router.push($linkCreator($i18n.locale, 'dashboard/tickets'))" style="width: 150px;background: rgb(89 201 126); color: white;">{{ $t('support') }}</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div :class="isAskingForDocuments ? 'col-lg-6' : 'col-lg-12'">
              <InputBox
                  v-for="control, index in formControls"
                  :key="index"
                  :type="control.type"
                  :label="$t(control.label)"
                  :validation="control.validation"
                  v-model="control.value"
                  @check-valid="control.isValid = $event"
                  :error-message="$t(control.errorMessage)"
              />
            </div>

            <div style="margin-bottom: 30px;" v-if="isAskingForDocuments" class="col-lg-6">
              <p>{{ $t('whyweneedid') }}</p>
              <div class="document-card">
                <font-awesome-icon
                    :icon="['fal', 'id-card']"
                    style="margin-right: 20px; font-size: 35px; width: 28px;"
                />
                <span>{{$t('government')}}</span>
              </div>
              <div class="document-card">
                <font-awesome-icon
                    :icon="['fal', 'id-badge']"
                    style="margin-right: 20px; font-size: 35px; width: 28px;"
                />
                <span>{{$t('driver')}}</span>
              </div>
              <div class="document-card">
                <font-awesome-icon
                    :icon="['fal', 'passport']"
                    style="margin-right: 20px; font-size: 35px; width: 28px;"
                />
                <span>{{$t('national')}}</span>
              </div>


              <DropZone
                  @handle-data="uploadImage($event)"
              />

            </div>

            <Button
                custom-width="100%"
                :is-async="true"
                :callback="sendInfo"
                :is-disabled="!$isFormValid(formControls)"
            >
              Next
            </Button>
          </div>
        </div>
      </div>

    </PageContainer>
  </Page>
</template>

<script>
import PageContainer from "@/components/main/UI/PageContainer";
import Page from "@/components/main/UI/Page";
import InputBox from "@/components/main/UI/InputBox";
import Button from "@/components/main/UI/Button";
import axios from "@/plugins/axios";
import DropZone from "@/components/main/UI/DropZone";

export default {
  name: "template",
  components: {
    PageContainer,
    Page,
    InputBox,
    Button,
    DropZone
  },
  data() {
    return {
      infoType: 'profile',
      formControls: {
        firstNameInput: {
          value: '',
          type: 'string',
          label: 'firstName',
          isValid: false,
          validation: {
            required: true
          }
        },
        lastNameInput: {
          value: '',
          type: 'string',
          label: 'lastName',
          isValid: false,
          validation: {
            required: true
          }
        },
        countryInput: {
          value: '',
          type: 'string',
          label: 'country',
          isValid: false,
          validation: {
            required: true
          }
        },
        dateInput: {
          value: '',
          type: 'date',
          label: 'date',
          isValid: false,
          validation: {
            required: true
          }
        }
      },
      dataLoadingStatus: {
        isDone: false,
        isError: false
      },
      isAskingForDocuments: false,
      loadingImage: null,
      verificationMessage: ''
    }
  },
  methods: {
    uploadImage(event) {
      this.loadingImage = event[0];
    },
    async sendInfo() {
      try {
        if (this.loadingImage === null && this.isAskingForDocuments) {
          this.$callNotification(
              this.$i18n.locale,
              {
                error: true,
                message: 'Upload document',
                timeout: 2000
              }
          );
          return;
        }
        const formData = new FormData();
        for (const input of Object.values(this.formControls)) {
          formData.append(input.label, input.value);
        }
        formData.append('verification-image', this.loadingImage);

        const fetchedData = await axios.post('/main/user/verification', formData);
        this.$callNotification(
            this.$i18n.locale,
            fetchedData
        );
        if (!fetchedData.data.error) return location.reload();
      } catch (error) {
        console.log(error)
        this.$callNotification(this.$i18n.locale, error);
      }
    }
  },
  async mounted() {
    try {
      let fetchedData = await axios.get('main/user/verification');
      if (fetchedData.data.error) {
        this.dataLoadingStatus.isDone = true;
        this.dataLoadingStatus.isError = true;
        return;
      }
      this.isAskingForDocuments = fetchedData.data.isAskingForDocuments;
      this.verificationMessage = fetchedData.data.verificationMessage;
      this.dataLoadingStatus.isDone = true;
    } catch (e) {
      this.dataLoadingStatus.isDone = true;
      this.dataLoadingStatus.isError = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-card {
  width: 800px;
  margin: auto;
  border-radius: 5px;
  color: #76808F;
  background-color: #fdfdfd;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 4px, rgba(0, 0, 0, 0.08) 0px 0px 2px;
  padding: 24px 24px 32px;

  h2, h3 {
    color: black;
  }

  &.dark {
    color: white !important;
    background-color: #1e1f20;

    h2, h3 {
      color: white !important;
    }
  }
}

.alert {
  position: relative;
  padding: 10px 60px;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  text-align: center;

&.alert-warning {
   color: #856404;
   background-color: #fff3cd;
   border-color: #ffeeba;
 }

&.alert-danger {
   color: #721c24;
   background-color: #f8d7da;
   border-color: #f5c6cb;
 }

&.alert-primary {
   color: #004085;
   background-color: #cce5ff;
   border-color: #b8daff;

 }

&.alert-success {
   color: #155724;
   background-color: #d4edda;
   border-color: #c3e6cb;
 }
}
.kyc {

  display: flex;
  justify-content: center;
}

.document-card {
  border: 1px solid #2A85FF;
  padding: 0 16px;
  height: 72px;
  display: flex;
  align-items: center;
  margin: 15px 0;
  color: #2A85FF;
  font-size: 17px;
}


@media (max-width: 768px) {
  .kyc {
    width: 100%;
  }
}

.kyc-tabs {
  float: right;
  display: flex;
  border: 1px solid black;
  padding: 0;
  margin-bottom: 20px;

  .kyc-tab {
    padding: 5px 15px;
    width: 50%;
    text-align: center;
    cursor: pointer;

    &.active {
      background: #2A85FF;
      color: white;
      transition: .3s;
    }
    &:first-child {
      border-right: 1px solid black;
    }
  }
}



</style>